import RouterFrame from '../../../../components/share/RouterFrame.vue'
import FinanceTaskVisibilityListing from '../../../../components/bundles/finance/admin/task-visibility/Listing.vue'

export default function (service, name) {
  return {
    path: 'widocznosc-rozliczen',
    component: RouterFrame,
    meta: {
      title: 'Widoczność rozliczeń',
      icon: 'eye',
      menuLink: true,
      acl: {
        service: service,
        action: 'get_settlement_visibilities'
      }
    },
    children: [
      {
        path: '',
        component: FinanceTaskVisibilityListing,
        name: `${service}_task_visibility_listing`,
        meta: {
          title: 'Lista widoczności rozliczeń',
          acl: {
            service: service,
            action: 'get_settlement_visibilities'
          }
        }
      }
    ]
  }
}
